import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
// import axios from 'axios'
import * as _ from 'lodash';
// import consts from '@/common/consts'
import lostApi from '@/api/lost';
import moment from 'moment';
var state = {
  lostOrders: [],
  lostOrderRequestParams: {},
  lostRewardRequestParams: {},
  lostRewards: [],
  statistics: {},
  refundResult: {}
};
var mutations = {
  LOST_ORDERS: function LOST_ORDERS(state, lostOrders) {
    console.log('LOST_ORDERS', lostOrders);
    state.lostOrders = lostOrders;
  },
  LOST_ORDER_HANDLE_STATUS: function LOST_ORDER_HANDLE_STATUS(state, _ref) {
    var lostOrderId = _ref.lostOrderId,
      handleStatus = _ref.handleStatus;
    if (_.isArray(state.lostOrders)) {
      state.lostOrders.forEach(function (order) {
        if (order.id === lostOrderId) {
          order.handleStatus = handleStatus;
        }
      });
    }
  },
  LOST_ORDER_MATCH_STATUS: function LOST_ORDER_MATCH_STATUS(state, _ref2) {
    var lostId = _ref2.lostId,
      matchMessage = _ref2.matchMessage,
      matchStatus = _ref2.matchStatus,
      matchDriverName = _ref2.matchDriverName,
      matchDriverPhone = _ref2.matchDriverPhone,
      matchPlateNumber = _ref2.matchPlateNumber;
    if (_.isArray(state.lostOrders)) {
      state.lostOrders.forEach(function (order) {
        if (order.id === lostId) {
          order.matchStatus = matchStatus;
          order.matchDriverName = matchDriverName;
          order.matchDriverPhone = matchDriverPhone;
          order.matchMessage = matchMessage;
          order.matchPlateNumber = matchPlateNumber;
        }
      });
    }
  },
  OWNER_CONFIRM: function OWNER_CONFIRM(state, params) {
    console.log('OWNER_CONFIRM', params);
    var lostId = params.lostId,
      ownerConfirm = params.ownerConfirm,
      ownerRemark = params.ownerRemark;
    if (_.isArray(state.lostOrders)) {
      state.lostOrders.forEach(function (order) {
        if (order.id === lostId) {
          order.ownerConfirm = ownerConfirm;
          order.ownerRemark = ownerRemark;
        }
      });
    }
  },
  STATISTICS: function STATISTICS(state, stat) {
    state.statistics = stat;
  },
  WX_REFUND_RESULT: function WX_REFUND_RESULT(state, data) {
    console.log('WX_REFUND_RESULT', data);
    state.refundResult = data;
  },
  LOST_ORDER_REQUEST_PARAMS: function LOST_ORDER_REQUEST_PARAMS(state, data) {
    state.lostOrderRequestParams = data;
  },
  LOST_REWARDS: function LOST_REWARDS(state, data) {
    state.lostRewards = data;
  },
  LOST_REWARDS_REQUEST_PARAMS: function LOST_REWARDS_REQUEST_PARAMS(state, data) {
    state.lostRewardRequestParams = data;
  }
};
var actions = {
  loadRefundInfo: function () {
    var _loadRefundInfo = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3, lostId) {
      var commit, _yield$lostApi$loadRe, status, message, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref3.commit;
            _context.next = 3;
            return lostApi.loadRefundInfo(lostId);
          case 3:
            _yield$lostApi$loadRe = _context.sent;
            status = _yield$lostApi$loadRe.status;
            message = _yield$lostApi$loadRe.message;
            data = _yield$lostApi$loadRe.data;
            if (!(status === '0')) {
              _context.next = 13;
              break;
            }
            if (data) {
              data.lostId = data.bizStrId;
            }
            commit('WX_REFUND_RESULT', data);
            return _context.abrupt("return", data);
          case 13:
            return _context.abrupt("return", Promise.reject(message));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loadRefundInfo(_x, _x2) {
      return _loadRefundInfo.apply(this, arguments);
    }
    return loadRefundInfo;
  }(),
  loadRewardInfo: function () {
    var _loadRewardInfo = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, lostId) {
      var commit, _yield$lostApi$loadRe2, status, message, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref4.commit;
            _context2.next = 3;
            return lostApi.loadRewardInfo(lostId);
          case 3:
            _yield$lostApi$loadRe2 = _context2.sent;
            status = _yield$lostApi$loadRe2.status;
            message = _yield$lostApi$loadRe2.message;
            data = _yield$lostApi$loadRe2.data;
            if (!(status === '0')) {
              _context2.next = 11;
              break;
            }
            return _context2.abrupt("return", data);
          case 11:
            return _context2.abrupt("return", Promise.reject(message));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function loadRewardInfo(_x3, _x4) {
      return _loadRewardInfo.apply(this, arguments);
    }
    return loadRewardInfo;
  }(),
  loadDriverRewards: function () {
    var _loadDriverRewards = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5, params) {
      var commit, res, status;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref5.commit;
            console.log(' call loadDriverRewards', params);
            _context3.next = 4;
            return lostApi.loadDriverRewards(params);
          case 4:
            res = _context3.sent;
            // const { data, status, message } = res
            status = res.status;
            if (status === '0') {
              commit('LOST_REWARDS', res);
            } else {
              commit('LOST_REWARDS', []);
            }
            return _context3.abrupt("return", res);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function loadDriverRewards(_x5, _x6) {
      return _loadDriverRewards.apply(this, arguments);
    }
    return loadDriverRewards;
  }(),
  loadStatistics: function () {
    var _loadStatistics = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref6) {
      var commit, _yield$lostApi$getSta, status, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref6.commit;
            _context4.next = 3;
            return lostApi.getStatistics();
          case 3:
            _yield$lostApi$getSta = _context4.sent;
            status = _yield$lostApi$getSta.status;
            data = _yield$lostApi$getSta.data;
            if (!(status === '0')) {
              _context4.next = 11;
              break;
            }
            commit('STATISTICS', data);
            return _context4.abrupt("return", data);
          case 11:
            commit('STATISTICS', {});
            return _context4.abrupt("return", {});
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function loadStatistics(_x7) {
      return _loadStatistics.apply(this, arguments);
    }
    return loadStatistics;
  }(),
  /**
   * 使用最后一次列表请求参数来重新加载订单列表
   * @param commit
   * @param state
   * @param dispatch
   * @returns {*}
   */
  reloadLostOrders: function reloadLostOrders(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state,
      dispatch = _ref7.dispatch;
    console.log('reload lost orders');
    return dispatch('loadLostOrders', state.lostOrderRequestParams);
  },
  reloadLostOrder: function () {
    var _reloadLostOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref8, lostId) {
      var commit, state, dispatch, lostResp, data, status, message, LOST_ORDERS_DATA, order;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref8.commit, state = _ref8.state, dispatch = _ref8.dispatch;
            _context5.prev = 1;
            _context5.next = 4;
            return lostApi.loadLostOrders({
              lostId: lostId
            });
          case 4:
            lostResp = _context5.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context5.next = 13;
              break;
            }
            LOST_ORDERS_DATA = state.lostOrders;
            if (_.isArray(data) && data.length > 0) {
              order = data[0];
              LOST_ORDERS_DATA = LOST_ORDERS_DATA.map(function (item) {
                if (item.id === order.id) {
                  Object.assign(item, order);
                }
                return item;
              });
            }
            commit('LOST_ORDERS', LOST_ORDERS_DATA);
            return _context5.abrupt("return", lostResp);
          case 13:
            commit('LOST_ORDERS', []);
            return _context5.abrupt("return", Promise.reject(message));
          case 15:
            _context5.next = 20;
            break;
          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", Promise.reject('异常：' + _context5.t0));
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 17]]);
    }));
    function reloadLostOrder(_x8, _x9) {
      return _reloadLostOrder.apply(this, arguments);
    }
    return reloadLostOrder;
  }(),
  loadLostOrders: function () {
    var _loadLostOrders = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref9, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref9.commit;
            commit('LOST_ORDER_REQUEST_PARAMS', params);
            _context6.prev = 2;
            _context6.next = 5;
            return lostApi.loadLostOrders(params);
          case 5:
            lostResp = _context6.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context6.next = 13;
              break;
            }
            if (_.isArray(data)) {
              data.forEach(function (lost) {
                lost.isVip = _.isEqual(lost.payStatus, 1);
                if (_.isNumber(lost.payTime)) {
                  // lost.matchStatusText = consts.LOST_MATCH_STATUS_MAP[lost.matchStatus];
                  // lost.matchStatusText = 'ddfd';
                  lost.payVipDateStr = moment(lost.payTime).format('YYYY-MM-DD HH:mm');
                }
                if (_.isNumber(lost.matchTime) && !_.isEmpty(lost.handleStartDate)) {
                  var matchtime = moment(lost.matchTime);
                  var handleStartTime = moment(lost.handleStartDate);
                  lost.matchConsume = moment.duration(matchtime.diff(handleStartTime)).humanize();
                } else {
                  lost.matchConsume = '';
                }
              });
            }
            commit('LOST_ORDERS', data);
            return _context6.abrupt("return", lostResp);
          case 13:
            commit('LOST_ORDERS', []);
            return _context6.abrupt("return", Promise.reject(message));
          case 15:
            _context6.next = 20;
            break;
          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](2);
            return _context6.abrupt("return", Promise.reject('异常：' + _context6.t0));
          case 20:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 17]]);
    }));
    function loadLostOrders(_x10, _x11) {
      return _loadLostOrders.apply(this, arguments);
    }
    return loadLostOrders;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};